import { Component } from '@angular/core';
import { fuseAnimations } from '../../../../core/animations';
import { TranslateService } from '@ngx-translate/core';
import { FuseConfigService } from '../../../../core/services/config.service';
import { Router } from '@angular/router';
import { UserService} from '../../../../core/services/users.service';

@Component({
    selector: 'privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class PrivacyComponent{

  public lang;
  public text = '';

  constructor(private translate: TranslateService, private fuseConfig: FuseConfigService, private router: Router, private userService: UserService) {
    this.lang = this.translate.currentLang;
    this.getPrivacy();
    this.translate.onLangChange.subscribe(res => {
      this.lang = res.lang;
      this.getPrivacy();
    });

  }

  getPrivacy() {
    this.userService.privacyAdmin(this.lang).subscribe((res: any) => {
      this.text = res.text;
      console.log(this.text);
    });
  }

  confirm() {
    this.userService.confirmPrivacy().subscribe((res) => {
      if (res) {
        localStorage.setItem('privacy', 'true');
        this.fuseConfig.setPrivacy(true);
        this.router.navigate([ '/pages/event' ]);
      }
    });
  }
}
